(function () {
  var root = document.getElementById("ca-ask");
  var configNode = document.getElementById("ca-ask-config");
  if (!root || !configNode) return;
  var config = {};
  try { config = JSON.parse(configNode.textContent || "{}"); } catch (error) { config = {}; }
  var endpoint = typeof config.endpoint === "string" ? config.endpoint : "";
  if (!/^https:\/\//.test(endpoint)) return;
  var shopRoot = typeof config.shop === "string" ? config.shop.replace(/\/$/, "") : "";

  var log = root.querySelector("[data-ask-log]");
  var form = root.querySelector("[data-ask-form]");
  var input = root.querySelector("[data-ask-input]");
  var examples = root.querySelector("[data-ask-examples]");
  var fileInput = root.querySelector("[data-ask-file]");
  var apiMessages = [];
  var map = new Map();
  var mapPromise = null;
  var shopCache = new Map();
  var busy = false;
  var pendingPhoto = null;
  var UNAVAILABLE = "The product assistant is unavailable right now. You can still search the catalogue, or contact Creative Automation sales.";
  var SLOW = "This is taking longer than usual, please try again or send a closer photo of the part code.";

  document.querySelectorAll("[data-zoho-id]").forEach(function (node) {
    var id = node.getAttribute("data-zoho-id");
    var url = node.getAttribute("href") || node.getAttribute("data-url");
    if (id && url) map.set(String(id), url);
  });

  function openPanel(seed) {
    root.hidden = false;
    document.body.style.overflow = "hidden";
    if (typeof seed === "string") input.value = seed;
    input.focus();
  }

  function closePanel() {
    root.hidden = true;
    document.body.style.overflow = "";
  }

  function queryFrom(node) {
    if (!node) return "";
    var explicit = node.getAttribute("data-ask-query");
    if (explicit) return explicit;
    var field = node.querySelector("[data-ask-seed]");
    return field && "value" in field ? field.value : "";
  }

  function eventElement(target) {
    if (!target) return null;
    return target.nodeType === 1 ? target : target.parentElement;
  }

  document.addEventListener("click", function (event) {
    var el = eventElement(event.target);
    if (!el) return;
    if (el.closest("[data-ask-chip]")) {
      var chip = el.closest("[data-ask-chip]");
      event.preventDefault();
      send(chip.getAttribute("data-ask-chip") || "");
      return;
    }
    var photoOpen = el.closest("[data-ask-photo-open]");
    if (photoOpen) {
      event.preventDefault();
      openPanel("");
      var panelPhoto = root.querySelector("[data-ask-photo]");
      if (panelPhoto) panelPhoto.click();
      return;
    }
    var queryNode = el.closest("[data-ask-query]");
    if (queryNode && !queryNode.matches("form")) {
      event.preventDefault();
      var query = queryNode.getAttribute("data-ask-query") || queryFrom(queryNode);
      openPanel("");
      if (String(query).trim()) send(String(query).trim());
      return;
    }
    var opener = el.closest("[data-ask-open]");
    if (opener && !opener.matches("form")) {
      event.preventDefault();
      openPanel("");
      return;
    }
    if (el.closest("[data-ask-close]")) closePanel();
  });

  document.addEventListener("submit", function (event) {
    var headerForm = event.target;
    if (!headerForm || !headerForm.hasAttribute || !headerForm.hasAttribute("data-ask-open")) return;
    var field = headerForm.querySelector("[data-ask-seed]") || headerForm.querySelector("input[name='ask']");
    var query = field ? String(field.value || "") : "";
    event.preventDefault();
    if (field) field.value = "";
    openPanel("");
    if (query.trim()) send(query.trim());
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !root.hidden) closePanel();
  });

  function shopPath(path) {
    if (shopRoot && path.charAt(0) === "/") return shopRoot + path;
    return path;
  }

  function textOf(content) {
    if (typeof content === "string") return content;
    if (!Array.isArray(content)) return "";
    return content.filter(function (block) { return block && block.type === "text" && block.text; }).map(function (block) { return block.text; }).join("\n");
  }

  function earlierAskTurn(turn) {
    if (!turn || typeof turn.content === "string") return turn;
    var blocks = Array.isArray(turn.content) ? turn.content : [];
    var photos = blocks.filter(function (block) { return block && block.type === "image"; }).length;
    var text = textOf(blocks);
    if (!photos) return text ? { role: turn.role, content: text } : turn;
    var note = photos === 1 ? "Photo sent earlier." : photos + " photos sent earlier.";
    return { role: turn.role, content: [text, note].filter(Boolean).join("\n").slice(0, 500) };
  }

  function outgoingAskHistory(previous, userContent) {
    var older = (Array.isArray(previous) ? previous : []).map(earlierAskTurn);
    return older.concat([{ role: "user", content: userContent }]).slice(-12);
  }

  function shopReply(text) {
    var shown = String(text || "").split(/(?<=[.!?])\s+/).filter(function (sentence) {
      return !/\b(request|other brands|on order|price on request|not in (?:our )?stock)\b/i.test(sentence);
    }).join(" ").trim();
    return shown || String(text || "").trim();
  }

  function followChips(reply) {
    var text = String(reply || "");
    if (/what coil voltage/i.test(text)) return ["24VDC", "110VAC", "230VAC"];
    if (/normally open or normally closed/i.test(text)) return ["Normally open", "Normally closed"];
    if (/cable or connector/i.test(text)) return ["Cable", "Connector"];
    if (/inductive, photoelectric/i.test(text)) return ["Inductive", "Photoelectric", "Limit switch"];
    if (/5\/2/.test(text) && /3\/2/.test(text)) return ["5/2", "3/2"];
    if (/pnp or npn/i.test(text)) return ["M18 PNP", "M18 NPN", "M12 PNP"];
    if (/what range, in bar/i.test(text)) return ["0-10 bar", "0-16 bar"];
    if (/bore and stroke/i.test(text)) return ["32 mm bore", "50 mm bore"];
    return [];
  }

  function formatAed(amount) {
    var negative = amount < 0;
    var parts = Math.abs(amount).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (negative ? "-" : "") + "AED " + parts[0] + "." + parts[1];
  }

  function priceInc(product) {
    if (typeof product.priceIncVat === "number") return product.priceIncVat;
    if (typeof product.priceExVat !== "number") return null;
    var vat = typeof product.vatPercentage === "number" ? product.vatPercentage : 5;
    return Math.round((product.priceExVat * (1 + vat / 100) + Number.EPSILON) * 100) / 100;
  }

  function stockLabel(product) {
    if (typeof product.availability === "string" && product.availability.trim()) return product.availability.trim();
    if (typeof product.availableForSale !== "number") return "";
    var qty = Math.abs(product.availableForSale - Math.round(product.availableForSale)) < 1e-9 ? String(Math.round(product.availableForSale)) : product.availableForSale.toFixed(1);
    var unit = product.unit || "PCE";
    var low = (unit === "PCE" || unit === "SET") && product.availableForSale < 5;
    return low ? "Only " + qty + " " + unit + " left" : qty + " " + unit + " available";
  }

  function isFesto(product) {
    return /\bfesto\b/i.test([product.brand, product.name, product.sku].filter(Boolean).join(" "));
  }

  function addBubble(role, text, error, extra) {
    var node = document.createElement("div");
    node.className = "ca-bubble ca-bubble--" + (error ? "error" : role === "user" ? "user" : "ai");
    if (extra) node.className += " " + extra;
    if (role === "assistant" && !error) node.appendChild(renderReply(text));
    else node.textContent = text;
    log.appendChild(node);
    log.scrollTop = log.scrollHeight;
    return node;
  }

  function pushInline(list, text, bold, italic) {
    if (!text) return;
    var last = list[list.length - 1];
    if (last && last.bold === bold && last.italic === italic) last.text += text;
    else list.push({ text: text, bold: bold, italic: italic });
  }

  function inlines(source) {
    var list = [];
    var pattern = /\*\*([^*]+)\*\*|\*([^*\n]+)\*|_([^_\n]+)_/g;
    var match;
    var cursor = 0;
    while ((match = pattern.exec(source))) {
      if (match.index > cursor) pushInline(list, source.slice(cursor, match.index).replace(/\*\*/g, ""), false, false);
      if (match[1] != null) pushInline(list, match[1], true, false);
      else pushInline(list, match[2] || match[3] || "", false, true);
      cursor = match.index + match[0].length;
    }
    if (cursor < source.length) pushInline(list, source.slice(cursor).replace(/\*\*/g, ""), false, false);
    return list;
  }

  function renderReply(text) {
    var wrap = document.createElement("div");
    wrap.className = "ca-md";
    String(text || "").replace(/\r\n/g, "\n").split("\n").forEach(function (line) {
      var bullet = line.match(/^\s*(?:[-•]|\*(?!\*))\s+(.*)$/);
      var source = bullet ? bullet[1].trim() : line.trim();
      if (!source) return;
      var row = document.createElement("p");
      if (bullet) row.appendChild(document.createTextNode("• "));
      inlines(source).forEach(function (part) {
        var node = part.bold || part.italic ? document.createElement(part.bold ? "strong" : "em") : document.createTextNode(part.text);
        if (part.bold || part.italic) node.textContent = part.text;
        row.appendChild(node);
      });
      wrap.appendChild(row);
    });
    return wrap;
  }

  function safePath(url) {
    if (typeof url !== "string") return "";
    var path = url.split("?")[0];
    if (path.indexOf("/products/") === 0 || path.indexOf("/collections/") === 0) return url;
    return "";
  }

  function loadZohoMap() {
    if (mapPromise) return mapPromise;
    mapPromise = (async function () {
      var base = typeof config.mapUrl === "string" ? config.mapUrl : "";
      if (!base) return map;
      var page = 1;
      var pages = 1;
      while (page <= pages && page <= 40) {
        var url = base + (base.indexOf("?") >= 0 ? "&" : "?") + "page=" + page;
        var response;
        try { response = await fetch(url, { headers: { accept: "application/json,text/plain,*/*" } }); }
        catch (error) { break; }
        if (!response.ok) break;
        var data;
        try { data = JSON.parse(await response.text()); }
        catch (error) { break; }
        pages = Number(data.pages) || 1;
        (data.items || []).forEach(function (item) {
          if (item && item.id != null && item.url) map.set(String(item.id), item.url);
        });
        page += 1;
      }
      return map;
    })();
    return mapPromise;
  }

  async function productHref(product) {
    var id = product && product.id != null ? String(product.id) : "";
    if (id && map.has(id)) return safePath(map.get(id));
    await loadZohoMap();
    if (id && map.has(id)) return safePath(map.get(id));
    return "";
  }

  function imageUrl(value) {
    if (!value) return "";
    if (typeof value === "string") return value.indexOf("//") === 0 ? "https:" + value : value;
    if (value.url) return imageUrl(value.url);
    if (value.src) return imageUrl(value.src);
    return "";
  }

  function foldCode(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function handleFrom(url) {
    var path = String(url || "").split("?")[0];
    var match = path.match(/\/products\/([^/]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function pickVariant(body, sku, loose) {
    var variants = body && Array.isArray(body.variants) ? body.variants : [];
    if (!variants.length) return null;
    var key = foldCode(sku);
    var matched = variants.find(function (item) { return key && foldCode(item.sku) === key; });
    if (matched) return matched;
    if (key && foldCode(body.title).indexOf(key) >= 0) {
      return variants.find(function (item) { return item.available; }) || variants[0];
    }
    if (!loose) return null;
    if (variants.length === 1) return variants[0];
    var available = variants.filter(function (item) { return item.available; });
    return available.length === 1 ? available[0] : null;
  }

  async function shopifyMatch(product) {
    var sku = String(product.sku || "").trim();
    var key = sku.toLowerCase();
    if (key && shopCache.has(key)) return shopCache.get(key);
    var found = { href: "", image: "", variantId: null };
    var loose = null;
    var bodies = new Map();

    async function loadProduct(handle) {
      if (!handle) return null;
      if (bodies.has(handle)) return bodies.get(handle);
      var response;
      try { response = await fetch(shopPath("/products/" + encodeURIComponent(handle) + ".js"), { headers: { accept: "application/json" } }); }
      catch (error) { bodies.set(handle, null); return null; }
      if (!response.ok) { bodies.set(handle, null); return null; }
      var body = await response.json().catch(function () { return null; });
      bodies.set(handle, body && Array.isArray(body.variants) ? body : null);
      return bodies.get(handle);
    }

    function pack(body, variant, imageHint) {
      if (!body || !variant || variant.id == null) return null;
      return {
        href: "/products/" + body.handle,
        image: imageUrl(body.featured_image || (body.images && body.images[0]) || imageHint),
        variantId: variant.id,
      };
    }

    function take(body, imageHint) {
      if (!body) return null;
      var strict = pack(body, pickVariant(body, sku, false), imageHint);
      if (strict) return strict;
      if (!loose) loose = pack(body, pickVariant(body, sku, true), imageHint);
      return null;
    }

    if (sku) {
      var suggestUrl = shopPath("/search/suggest.json?q=" + encodeURIComponent(sku) + "&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.sku,vendor");
      var suggest;
      try { suggest = await fetch(suggestUrl, { headers: { accept: "application/json" } }).then(function (response) { return response.ok ? response.json() : null; }); }
      catch (error) { suggest = null; }
      var list = suggest && suggest.resources && suggest.resources.results && suggest.resources.results.products || [];
      for (var i = 0; i < list.length && i < 4; i += 1) {
        var hit = take(await loadProduct(list[i].handle), list[i].image || list[i].featured_image);
        if (hit) {
          found = hit;
          break;
        }
        if (!found.href && list[i].url) {
          found.href = safePath(list[i].url);
          found.image = imageUrl(list[i].image || list[i].featured_image);
        }
      }
      if (!found.variantId) {
        var handle = sku.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
        var direct = take(await loadProduct(handle), "");
        if (direct) found = direct;
      }
    }
    if (!found.variantId && loose) found = loose;
    if (!found.href) found.href = await productHref(product);
    if (!found.variantId && found.href) {
      var linked = take(await loadProduct(handleFrom(found.href)), found.image);
      if (linked) found = linked;
      else if (loose) found = loose;
    }
    if (key) shopCache.set(key, found);
    return found;
  }

  function refreshCartCount() {
    return fetch(shopPath("/cart.js"), { headers: { accept: "application/json" } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll("[data-cart-count]").forEach(function (node) {
          var count = cart.item_count || 0;
          node.textContent = count > 99 ? "99" : String(count);
          node.hidden = count < 1;
        });
      })
      .catch(function () {});
  }

  async function renderProducts(products, stockFit) {
    var exact = stockFit === "exact";
    var close = stockFit === "close";
    var wrap = document.createElement("div");
    wrap.className = "ca-ask__cards";
    var heading = document.createElement("p");
    heading.className = "ca-ask__cards-label";
    heading.textContent = exact ? "Exact part" : close ? (products.length > 1 ? "Close alternatives" : "Close alternative") : "In stock";
    wrap.appendChild(heading);
    var row = close && products.length > 1 ? document.createElement("div") : null;
    if (row) {
      row.className = "ca-ask__row";
      wrap.appendChild(row);
    }
    for (var i = 0; i < products.length; i += 1) {
      await appendCard(products[i], row || wrap);
    }
    return wrap;

    async function appendCard(product, host) {
      var shop = await shopifyMatch(product);
      var card = document.createElement("article");
      card.className = "ca-ask__card";
      if (shop.image) {
        var photo = document.createElement("img");
        photo.src = shop.image;
        photo.alt = "";
        photo.width = 88;
        photo.height = 88;
        card.appendChild(photo);
      } else {
        var placeholder = document.createElement("span");
        placeholder.className = "ca-ask__ph";
        placeholder.textContent = String(product.brand || product.name || "?").trim().charAt(0).toUpperCase() || "?";
        card.appendChild(placeholder);
      }
      var body = document.createElement("div");
      body.className = "ca-ask__card-body";
      if (exact) {
        var badge = document.createElement("span");
        badge.className = "ca-stock";
        badge.textContent = "In stock";
        body.appendChild(badge);
      }
      var name = document.createElement("span");
      name.className = "ca-card__name";
      name.textContent = product.name || product.sku || "Part";
      body.appendChild(name);
      var meta = document.createElement("span");
      meta.className = "ca-meta";
      meta.textContent = [product.brand, product.sku].filter(Boolean).join(" · ");
      body.appendChild(meta);
      var amount = priceInc(product);
      if (amount != null) {
        var price = document.createElement("span");
        price.className = "ca-price";
        price.textContent = formatAed(amount);
        body.appendChild(price);
        var vat = document.createElement("span");
        vat.className = "ca-meta";
        vat.textContent = "incl. VAT";
        body.appendChild(vat);
      }
      var stock = stockLabel(product);
      if (stock) {
        var line = document.createElement("span");
        line.className = "ca-stock";
        line.textContent = stock;
        body.appendChild(line);
      }
      var actions = document.createElement("div");
      actions.className = "ca-ask__actions";
      if (shop.variantId) {
        var add = document.createElement("button");
        add.type = "button";
        add.className = "ca-ask__add";
        add.textContent = "Add to cart";
        add.addEventListener("click", function (event) {
          var button = event.currentTarget;
          var id = shop.variantId;
          button.disabled = true;
          fetch(shopPath("/cart/add.js"), {
            method: "POST",
            headers: { "content-type": "application/json", accept: "application/json" },
            body: JSON.stringify({ id: id, quantity: 1 }),
          }).then(function (response) {
            if (response.ok) {
              button.textContent = "Added";
              return refreshCartCount();
            }
            return response.json().catch(function () { return null; }).then(function (body) {
              var message = body && (body.description || body.message) || "";
              button.textContent = /sold out/i.test(message) ? "Sold out" : "Add to cart";
              if (!/sold out/i.test(message)) button.disabled = false;
            });
          }).catch(function () {
            button.disabled = false;
            button.textContent = "Add to cart";
          });
        });
        actions.appendChild(add);
      }
      if (shop.href) {
        var view = document.createElement("a");
        view.className = "ca-ask__view";
        view.href = shop.href.charAt(0) === "/" ? shopPath(shop.href.split("?")[0]) : shop.href;
        view.textContent = "View";
        actions.appendChild(view);
      }
      if (actions.childNodes.length) body.appendChild(actions);
      card.appendChild(body);
      host.appendChild(card);
    }
  }

  function renderChips(labels) {
    var row = document.createElement("div");
    row.className = "ca-ask__chips";
    labels.forEach(function (label) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "rps_ignore_search_input";
      button.setAttribute("data-ask-chip", label);
      button.textContent = label;
      row.appendChild(button);
    });
    return row;
  }

  function readFile(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(String(reader.result || "")); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function readNdjson(response, onEvent) {
    if (!response.body || !response.body.getReader) {
      return response.text().then(function (text) { return parseNdjsonText(text, onEvent); });
    }
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = "";
    var result = null;
    function consume(line) {
      var trimmed = String(line || "").trim();
      if (!trimmed) return;
      var event;
      try { event = JSON.parse(trimmed); } catch (error) { return; }
      if (onEvent) onEvent(event);
      if (event && event.type === "result") result = event;
      if (event && event.type === "error") result = { error: event.error || UNAVAILABLE };
    }
    function pump() {
      return reader.read().then(function (step) {
        if (step.done) {
          if (buffer.trim()) consume(buffer);
          return result;
        }
        buffer += decoder.decode(step.value, { stream: true });
        var lines = buffer.split("\n");
        buffer = lines.pop();
        lines.forEach(consume);
        return pump();
      });
    }
    return pump();
  }

  function parseNdjsonText(text, onEvent) {
    var result = null;
    String(text || "").split("\n").forEach(function (line) {
      var trimmed = line.trim();
      if (!trimmed) return;
      var event;
      try { event = JSON.parse(trimmed); } catch (error) { return; }
      if (onEvent) onEvent(event);
      if (event && event.type === "result") result = event;
      if (event && event.type === "error") result = { error: event.error || UNAVAILABLE };
    });
    return result;
  }

  function replyFrom(payload) {
    if (!payload || typeof payload !== "object") return "";
    if (typeof payload.reply === "string") return payload.reply;
    if (payload.result && typeof payload.result.reply === "string") return payload.result.reply;
    return "";
  }

  var preview = document.createElement("div");
  preview.className = "ca-ask__preview";
  preview.hidden = true;
  var previewImg = document.createElement("img");
  previewImg.alt = "";
  previewImg.width = 72;
  previewImg.height = 72;
  var previewRemove = document.createElement("button");
  previewRemove.type = "button";
  previewRemove.className = "ca-ask__preview-remove";
  previewRemove.textContent = "×";
  previewRemove.setAttribute("aria-label", "Remove photo");
  preview.appendChild(previewImg);
  preview.appendChild(previewRemove);
  if (form) form.insertBefore(preview, form.firstChild);
  previewRemove.addEventListener("click", function () { clearPhoto(); });

  function clearPhoto() {
    pendingPhoto = null;
    preview.hidden = true;
    previewImg.removeAttribute("src");
  }

  function showPhoto(photo) {
    pendingPhoto = photo;
    previewImg.src = photo.previewUri;
    preview.hidden = false;
  }

  function clearProgressNotes() {
    log.querySelectorAll("[data-ask-pending], [data-ask-progress]").forEach(function (node) {
      if (node.parentNode) node.remove();
    });
  }

  async function send(text, photo) {
    var query = String(text || "").trim().slice(0, 500);
    var shot = photo || null;
    if (busy || (!query && !shot)) return;
    var userContent = shot
      ? [].concat(query ? [{ type: "text", text: query }] : [], [{ type: "image", source: { type: "base64", media_type: shot.mediaType, data: shot.data } }])
      : query;
    var history = outgoingAskHistory(apiMessages, userContent);
    apiMessages = apiMessages.concat([{ role: "user", content: query || "Photo sent." }]).slice(-12);
    busy = true;
    if (examples) examples.hidden = true;
    if (shot && shot.previewUri) {
      var thumb = document.createElement("img");
      thumb.className = "ca-ask__thumb";
      thumb.alt = "";
      thumb.src = shot.previewUri;
      thumb.width = 160;
      thumb.height = 120;
      log.appendChild(thumb);
    }
    if (query) addBubble("user", query);
    var pending = addBubble("assistant", "Checking the catalogue…", false, "ca-bubble--progress");
    pending.setAttribute("data-ask-pending", "");
    var lastProgress = "";
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 75000);
    try {
      var response = await fetch(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/x-ndjson, application/json" },
        body: JSON.stringify({ messages: history, stream: true }),
        signal: controller.signal,
      });
      var ctype = (response.headers.get("content-type") || "").toLowerCase();
      var payload = null;
      if (response.status !== 429 && ctype.indexOf("ndjson") !== -1) {
        payload = await readNdjson(response, function (event) {
          if (!event || event.type !== "progress" || !event.text) return;
          var step = String(event.text);
          if (step === lastProgress) return;
          lastProgress = step;
          if (pending && pending.parentNode) pending.remove();
          pending = null;
          var note = addBubble("assistant", step, false, "ca-bubble--progress");
          note.setAttribute("data-ask-progress", "");
        });
      } else {
        payload = await response.json().catch(function () { return null; });
      }
      clearProgressNotes();
      if (response.status === 429) {
        addBubble("assistant", (payload && payload.error) || "Too many questions from this network. Wait a few minutes and try again.", true);
        return;
      }
      var reply = replyFrom(payload);
      if (!response.ok || !reply) {
        addBubble("assistant", (payload && payload.error) || UNAVAILABLE, true);
        return;
      }
      apiMessages = apiMessages.concat([{ role: "assistant", content: reply }]).slice(-12);
      var bubble = addBubble("assistant", shopReply(reply));
      if (payload && typeof payload.readHint === "string" && payload.readHint.trim()) {
        var hint = document.createElement("p");
        hint.className = "ca-meta";
        hint.textContent = payload.readHint.trim();
        bubble.appendChild(hint);
      }
      var chips = followChips(reply);
      if (chips.length) bubble.appendChild(renderChips(chips));
      var products = Array.isArray(payload.products) ? payload.products.filter(function (item) { return item && (item.id || item.sku) && !isFesto(item); }) : [];
      var stockFit = payload.stockFit;
    } catch (error) {
      clearProgressNotes();
      addBubble("assistant", error && error.name === "AbortError" ? SLOW : UNAVAILABLE, true);
    } finally {
      window.clearTimeout(timer);
      busy = false;
      log.scrollTop = log.scrollHeight;
    }
    if (bubble && products && products.length) {
      var cards = await renderProducts(products.slice(0, 6), stockFit);
      if (bubble.isConnected) bubble.appendChild(cards);
      log.scrollTop = log.scrollHeight;
    }
  }

  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var text = input.value;
      var shot = pendingPhoto;
      input.value = "";
      clearPhoto();
      send(text, shot);
    });
  }

  root.querySelectorAll("[data-ask-example]").forEach(function (button) {
    button.addEventListener("click", function () { send(button.getAttribute("data-ask-example")); });
  });

  var choices = document.createElement("div");
  choices.className = "ca-ask__choices";
  choices.hidden = true;
  var take = document.createElement("button");
  take.type = "button";
  take.textContent = "Take photo";
  var upload = document.createElement("button");
  upload.type = "button";
  upload.textContent = "Upload image";
  choices.appendChild(take);
  choices.appendChild(upload);
  if (form && fileInput) form.insertBefore(choices, fileInput);

  var photoButton = root.querySelector("[data-ask-photo]");
  if (photoButton && fileInput) {
    photoButton.addEventListener("click", function () { choices.hidden = !choices.hidden; });
    take.addEventListener("click", function () {
      fileInput.setAttribute("capture", "environment");
      fileInput.click();
    });
    upload.addEventListener("click", function () {
      fileInput.removeAttribute("capture");
      fileInput.click();
    });
    fileInput.addEventListener("change", async function () {
      var file = fileInput.files && fileInput.files[0];
      fileInput.value = "";
      choices.hidden = true;
      if (!file) return;
      var dataUrl = await readFile(file);
      var data = dataUrl.split(",")[1] || "";
      var bytes = Math.floor((data.length * 3) / 4);
      if (bytes > 5 * 1024 * 1024) {
        addBubble("assistant", "That photo is still too large. Use a smaller photo of the label.", true);
        return;
      }
      var type = file.type === "image/png" || file.type === "image/webp" ? file.type : "image/jpeg";
      if (!data) {
        addBubble("assistant", "Could not read that photo.", true);
        return;
      }
      showPhoto({ mediaType: type, data: data, previewUri: dataUrl });
    });
  }

  if (config.open === true) openPanel("");

  var searchQueryNode = document.getElementById("ca-search-query");
  var initialQuery = "";
  if (searchQueryNode) {
    try {
      var parsed = JSON.parse(searchQueryNode.textContent || "null");
      if (typeof parsed === "string") initialQuery = parsed;
    } catch (error) { initialQuery = ""; }
  }
  if (!String(initialQuery).trim() && typeof URLSearchParams !== "undefined") {
    initialQuery = new URLSearchParams(window.location.search).get("ask") || "";
  }
  var headerSeed = document.querySelector(".tm-search [data-ask-seed]");
  if (headerSeed && String(initialQuery).trim()) headerSeed.value = String(initialQuery);
  if (document.body.classList.contains("template-search")) {
    openPanel("");
    if (String(initialQuery).trim()) send(String(initialQuery).trim());
  }
})();
